import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <section className="relative w-full overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url(https://readdy.ai/api/search-image?query=Stylized%20cinematic%20anime%20key%20visual%20with%20warm%20orange%20and%20gold%20palette%2C%20energetic%20characters%20flying%20through%20sparkling%20night%20sky%20with%20glowing%20sakura%20and%20starlight%2C%20epic%20composition%2C%20rich%20contrast%20for%20readable%20overlay%20text&width=1600&height=900&seq=hero-2026-v1&orientation=landscape)",
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/35 to-background-950/70"></div>

      <div className="relative mx-auto flex w-full min-h-[600px] md:min-h-[720px] flex-col items-center justify-center px-4 pt-24 pb-20 text-center">
        <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-sm text-background-50 backdrop-blur">
          <i className="ri-flashlight-fill text-accent-400"></i>
          动漫网 · 2026 新番索引已上线
        </span>

        <h1 className="mt-6 max-w-3xl font-heading text-4xl leading-tight text-background-50 md:text-6xl">
          动漫网全部动漫列表
          <br />
          <span className="text-accent-400">一站式</span> 检索入口
        </h1>

        <p className="mt-5 max-w-2xl text-base leading-relaxed text-background-50/90 md:text-lg">
          新番索引、漫画分类大全、国漫专区、日漫检索、动画库一站配齐。
          找漫画、追更新不用再翻来翻去，点开就能直达全部动漫。
        </p>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
          <Link
            to="/categories"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-search-line"></i>
            检索全部动漫
          </Link>
          <Link
            to="/categories?cat=xinfan"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-50/40 bg-background-50/10 px-7 py-3 text-sm font-semibold text-background-50 backdrop-blur transition-colors hover:bg-background-50/20"
          >
            <i className="ri-fire-line text-accent-400"></i>
            查看新番索引
          </Link>
        </div>

        <dl className="mt-12 flex flex-wrap items-center justify-center gap-x-8 gap-y-4 text-background-50">
          <div className="text-center">
            <dt className="text-xs uppercase tracking-wider text-background-50/70">分类大全</dt>
            <dd className="mt-1 font-heading text-2xl md:text-3xl">10+</dd>
          </div>
          <div className="h-10 w-px bg-background-50/25"></div>
          <div className="text-center">
            <dt className="text-xs uppercase tracking-wider text-background-50/70">收录动漫</dt>
            <dd className="mt-1 font-heading text-2xl md:text-3xl">1200+</dd>
          </div>
          <div className="h-10 w-px bg-background-50/25"></div>
          <div className="text-center">
            <dt className="text-xs uppercase tracking-wider text-background-50/70">国漫日漫</dt>
            <dd className="mt-1 font-heading text-2xl md:text-3xl">一站配齐</dd>
          </div>
        </dl>
      </div>
    </section>
  );
}